import { takeLatest, takeEvery, put, call } from "redux-saga/effects";
import apiCall from "../services"
import config from '../config/config.json';


function* tag(actions) {

    try {
      
        const headers = {
            'Content-Type': "application/json",
            'Authorization': `Bearer ${actions.access}`
        };

        const requestOptions = {
            headers: headers
        };
        
        let url = (actions.query === null) ? config.credentials.url + '/tags/' : config.credentials.url + '/tags/' + actions.query
        
        const response = yield call(apiCall, 'get', url, requestOptions)
     
        yield put({ type: "TAG_RESPONSE", value: response })

    } catch (error) {
        yield put({ type: "TAG_RESPONSE", value: error })
    }
}

function* tags(actions) {

    try {
        
        const headers = {
            'Content-Type': "application/json",
            'Authorization': `Bearer ${actions.access}`
        };

        const requestOptions = {
            headers: headers
        };
        
        let url = (actions.query === null) ? config.credentials.url + '/tags/?offset=0&limit='+actions.limit : config.credentials.url + '/tags/' + actions.query
        
        const response = yield call(apiCall, 'get', url, requestOptions)
     
        yield put({ type: "TAGS_RESPONSE_LIST", value: response })

    } catch (error) {
        yield put({ type: "TAGS_RESPONSE_LIST", value: error })
    }
}

function* add(actions) {

    try {

        const headers = {
            'Content-Type': "application/json",
            'Authorization': `Bearer ${actions.access}`
        };
        const requestOptions = {
            headers: headers,
            body: JSON.stringify(actions.data)
        };
         
        const response = yield call(apiCall, 'POST',config.credentials.url+'/tags/', requestOptions);

      

        yield put({ type: "TAG_RESPONSE", value: response })

    } catch (error) {
        yield put({ type: "TAG_RESPONSE", value: error })
    }
}


function* remove(actions) {

    try {

        const headers = {
            'Content-Type': "application/json",
            'Authorization': `Bearer ${actions.access}`
        };
 
        const requestOptions = {
            headers: headers
        };
 

        const response = yield call(apiCall, 'delete', config.credentials.url+ '/tags/' + actions.data+ '/', requestOptions)


        yield put({ type: "TAG_RESPONSE", value: response})
 
    } catch (error) {
        yield put({ type: "TAG_RESPONSE", value: error })
    }
}

function* edit(actions) {

    try {
      
        const headers = {
            'Content-Type': "application/json",
            'Authorization': `Bearer ${actions.access}`
        };
 
        const requestOptions = {
            headers: headers,
            body: JSON.stringify(actions.data)
        };
        
        const response = yield call(apiCall, 'put', config.credentials.url+ '/tags/' + actions.id+ '/', requestOptions)

        yield put({ type: "TAG_RESPONSE", value: response})
 
    } catch (error) {
        yield put({ type: "TAG_RESPONSE", value: error })
    }
}

function* officeMassiveTags(actions) {
    try {
        const headers = {
            'Content-Type': "application/json",
            'Authorization': `Bearer ${actions.access}`
        };
        const requestOptions = {
            headers: headers,
            body: JSON.stringify(actions.data)
        };
         
        const response = yield call(apiCall, 'POST',config.credentials.url+'/office_massive_tags/', requestOptions);

        yield put({ type: "MASSIVE_TAGS_RESPONSE", value: response })

    } catch (error) {
        yield put({ type: "MASSIVE_TAGS_RESPONSE", value: error })
    }
}


export function* getTag() {
    yield takeEvery("GET_TAG", tag)
}
export function* getTagsList() {
    yield takeEvery("GET_TAGS", tags)
}

export function* addTag() {
    yield takeEvery("ADD_TAG", add)
}

export function* removeTag() {
    yield takeEvery("REMOVE_TAG", remove)
}

export function* editTag() {
    yield takeEvery("EDIT_TAG", edit)
}

export function* postOfficeMassiveTags() {
    yield takeEvery("POST_MASSIVE_TAGS", officeMassiveTags)
}
